import {httpCreateProject, HttpCreateProjectOptions} from '@/features/projects/http/projects.http'
import {ProjectSmall} from '@/features/projects/types'
import {MUTATION_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreProject = (
    options?: UseMutationOptions<
        Omit<ProjectSmall, 'referringDoctor' | 'progressStatus'>, // todo: remove this omit once the backend is updated
        AxiosError<ErrorResponseData>,
        HttpCreateProjectOptions
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_PROJECT],
        mutationFn: httpCreateProject
    })
}
